const module = { name: 'Fandango/eventQueue', exports: {} }; const exports = module.exports;



const EventNames = Object.freeze({
    COVID_OVERLAY: 'covidOverlay',
    FAN_ALERT_READY: 'fanAlertReady',
    HP_FANALERT_ENTER_INPUT: 'fanAlertUserInput',
    HP_FANALERT_DONE: 'fanAlertDone',
    LOCATION_DROPDOWN_CLOSE: 'locDropdownClose',
    LOCATION_OVERLAY_CLOSE: 'locOverlayClose',
    MOP_FAN_CRITIC_REVIEWS_API: 'mopFanCriticReviews:success',
    AB_TEST_4455_READY: 'ABTEST[4455]:ready',
    AB_TEST_4476_READY: 'ABTEST[4476]:ready',
    AB_TEST_4608_READY: 'ABTEST[4608]:ready',
    AB_TEST_4844_READY: 'ABTEST[4844]:ready',
    AB_TEST_6254_READY: 'ABTEST[6254]:ready',
})


const allowedNames = Object.keys(EventNames).map(key => EventNames[key])


const Messages = {
    EVENT_NAME_MISSING: 'Attempt to use an undefined Event Name',
    INVALID_HANDLER: 'Handler must be a function'
}


let listeners = {}


const firedEvents = []
function addListener(eventName, eventHandler) {
    if (allowedNames.indexOf(eventName) === -1) {
        throw new Error(`${module.name} ${Messages.EVENT_NAME_MISSING} "${eventName}"`);
    }
    if (typeof eventHandler !== 'function') {
        throw new Error(`${module.name} ${Messages.INVALID_HANDLER} "${eventName}"`);
    }
    if (!Array.isArray(listeners[eventName])) {
        listeners[eventName] = [];
    }
    const index = listeners[eventName].push(eventHandler) - 1;
    return {
        remove() {
            delete listeners[eventName][index];
        }
    };
}
function emitEvent(eventName, payload) {
    if (allowedNames.indexOf(eventName) === -1) {
        throw new Error(`${module.name} ${Messages.EVENT_NAME_MISSING} "${eventName}"`);
    }
    firedEvents.push(eventName);
    if (!Array.isArray(listeners[eventName])) {
        return;
    }
    listeners[eventName].forEach(handler => handler(payload));
}
function resetQueue() {
    listeners = {};
}
function getQueue() {
    return listeners;
}
function extendLegacy(publicInterface, sectionName) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[sectionName]) {
        Fandango[sectionName] = publicInterface;
    }
}
module.exports = {
    __test__: {
        resetQueue,
        getQueue
    },
    on: addListener,
    emit: emitEvent,
    hasFired(eventName) {
        return firedEvents.includes(eventName);
    },
    EventNames,
};
extendLegacy(module.exports, 'eventQueue');
export default module.exports;